<script setup>
import { useWebSiteStore } from '@/stores/web-site.store'

import CompanyRoi from '@/components/planner/CompanyRoi.vue'

defineProps({
  company: {
    type: Object,
    required: true,
  },
})

const webSiteStore = useWebSiteStore()
</script>

<template>
  <q-card-section horizontal>
    <q-img
      v-if="company?.avatar_file || company?.avatar_url"
      class="q-ma-md"
      :src="company.avatar_file || company.avatar_url"
      fit="contain"
      style="max-width: 12rem; max-height: 12rem;"
    />
    <q-icon
      v-else
      class="q-ma-md"
      size="12rem"
      color="grey-5"
      name="mdi-camera-off"
    />
    <template v-if="webSiteStore.can(webSiteStore.permissionFlagEnum.FINANCIALS)">
      <q-separator vertical class="q-ma-md" />
      <company-roi class="col" :company="company" variant="info" />
    </template>
  </q-card-section>
</template>
